/**
 * Splits a full display name into firstName and optional lastName.
 * Used when saving display name from a single input (e.g. menu modal).
 * Split on first space: "Alon Smith" → { firstName: "Alon", lastName: "Smith" }; "Alon" → { firstName: "Alon" }.
 */

export interface SplitDisplayNameResult {
  firstName: string;
  /** Empty when the display name is a single word — caller should persist as null/empty last name. */
  lastName: string;
}

/**
 * Split a trimmed full name into firstName and lastName.
 * @param trimmedFullName - Already trimmed string (caller must trim).
 * @returns first word → firstName; everything after the first space (trimmed) → lastName, or '' if none.
 */
export function splitFullNameToFirstAndLast(trimmedFullName: string): SplitDisplayNameResult {
  const spaceIdx = trimmedFullName.indexOf(' ');
  if (spaceIdx < 0) {
    return { firstName: trimmedFullName, lastName: '' };
  }
  const firstName = trimmedFullName.slice(0, spaceIdx);
  const rest = trimmedFullName.slice(spaceIdx + 1).trim();
  return { firstName, lastName: rest };
}
